import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var Justify = forwardRef(function Justify(_a, ref) {
    var _b;
    var left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom, className = _a.className, props = __rest(_a, ["left", "right", "top", "bottom", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-justify-grid", className, (_b = {},
            _b[classPrefix + "-justify-grid--start"] = top,
            _b[classPrefix + "-justify-grid--end"] = bottom,
            _b)) }, props),
        left != null && (React.createElement("div", { className: classPrefix + "-justify-grid__col " + classPrefix + "-justify-grid__col--left" }, left)),
        right != null && (React.createElement("div", { className: classPrefix + "-justify-grid__col " + classPrefix + "-justify-grid__col--right" }, right))));
});
Justify.displayName = "Justify";
//# sourceMappingURL=Justify.js.map